<template>
  <v-dialog v-model="deveAbrir" :max-width="Modal.Confirmacao.larguraMaxima" persistent>
    <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima" class="mensagem-confirmacao">
      <v-card-title class="modal-title primary white--text" primary-title dark>
        <span>Aviso de saldo insuficiente!</span>
      </v-card-title>

      <v-card-text class="mensagem-confirmacao__texto px-3">
          <h3 class="text-xs-center mb-2" style="color: #BC8E05;"> ⚠️ Atenção!!! </h3>
        <ul class="aviso-lista">
          <li v-for="(item, index) in mensagensAlerta" :key="index" v-html="item"></li>
        </ul>
      </v-card-text>

      <v-card-actions class="px-3 py-2">
        <v-btn id="botaoRecusar" @click="$emit('cancelar')" outline depressed color="botao-cancelar-color">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn id="botaoConfirmar" @click="$emit('confirmar')" color="primary" depressed>
          Continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'AlertaAvisoValidacaoSaldo',
    props: {
        mensagensAlerta: {
            type: Array,
            required: true
        },
        deveAbrir: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            Modal
        }
    }
}
</script>

<style scoped lang="stylus">


.aviso-lista {
  background-color: transparent;
  color: #664d03;
  padding-left: 20px;
  word-wrap: break-word;
}

</style>
